import WineImageZoomLayer from './WineImageZoomLayer';

const WineImageFrame = ({
  wine,
  canHoverZoom,
  isHovering,
  mousePosition,
  imageContainerRef,
  setIsHovering,
  handleMouseMove,
  openFullScreen,
}) => {
  const interactionProps = canHoverZoom
    ? {
        onMouseEnter: () => setIsHovering(true),
        onMouseLeave: () => setIsHovering(false),
        onMouseMove: handleMouseMove,
        onDoubleClick: openFullScreen,
        onClick: openFullScreen,
      }
    : {};

  return (
    <div
      ref={imageContainerRef}
      className={`w-64 h-96 tablet-landscape:w-56 tablet-landscape:h-80 bg-gradient-to-br from-[#3a3545] to-[#2a2535] rounded-3xl flex items-center justify-center shadow-2xl overflow-hidden p-4 relative ${canHoverZoom ? 'group cursor-zoom-in' : ''}`}
      {...interactionProps}
    >
      <img
        src={wine.image}
        alt={wine.name}
        className={`max-h-full max-w-full object-contain transition-opacity duration-300 ${canHoverZoom && isHovering ? 'opacity-0' : 'opacity-100'}`}
        onError={(e) => {
          e.target.style.display = 'none';
        }}
        draggable={false}
      />
      {canHoverZoom && <WineImageZoomLayer wine={wine} isHovering={isHovering} mousePosition={mousePosition} />}
      {canHoverZoom && (
        <div className="absolute inset-0 flex flex-col items-center justify-end pb-4 pointer-events-none opacity-0 group-hover:opacity-100 bg-gradient-to-t from-black/50 via-transparent to-transparent transition-opacity">
          <span className="text-white/80 text-xs bg-black/40 px-3 py-1.5 rounded-full">Hover para ampliar</span>
        </div>
      )}
    </div>
  );
};

const WineImageViewer = (props) => (
  <div className="flex justify-center tablet-landscape:sticky tablet-landscape:top-4">
    <div className="relative">
      <WineImageFrame {...props} />
      <div className="absolute -inset-2 border border-wine-gold/20 rounded-[2rem] pointer-events-none" />
      <div className="absolute -top-4 -right-4 w-24 h-24 bg-wine-gold/10 rounded-full blur-2xl pointer-events-none" />
    </div>
  </div>
);

export default WineImageViewer;
